import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "PCMDataSheet/";

const getPCMDataSheetById = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetPCMDataSheetById?jobFormId=' + id, constants.REQUIRE_INTERCEPTORS);

const start = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'Start', model, constants.REQUIRE_INTERCEPTORS);

const save = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'Save', model, constants.REQUIRE_INTERCEPTORS);

const saveLineItem = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveLineItem', model, constants.REQUIRE_INTERCEPTORS);

const deleteLineItem = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'DeleteLineItem?id=' + id, constants.REQUIRE_INTERCEPTORS);

const getReportPdf = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetReportPdf?id=' + id, constants.REQUIRE_INTERCEPTORS);

const getUsersFromProjectInfoSheet = async (jobId, projectId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetUsersListFromProjectInfoSheet?jobId=' + jobId + "&projectId=" + projectId, constants.REQUIRE_INTERCEPTORS);

export {
    getPCMDataSheetById,
    start,
    save,
    saveLineItem,
    deleteLineItem,
    getReportPdf,
    getUsersFromProjectInfoSheet
}